import UserApiKeySettingsResourceModel from '../../generated/types/model/resource/UserApiKeySettingsResourceModel';

export default class UserApiKeySettingsResourceViewModel extends UserApiKeySettingsResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
